import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  ourWorks: [],
  singleWork: {},
  singleWorkGallery: [],
  ourWorksPageLoading: false
}

const getters = {
  ourWorks: (state) => state.ourWorks,
  singleWork: (state) => state.singleWork,
  singleWorkGallery: (state) => state.singleWorkGallery,
  ourWorksPageLoading: (state) => state.ourWorksPageLoading
}

const mutations = {
  setOurWorks(state, payload) {
    state.ourWorks = payload
  },
  setSingleWork(state, payload) {
    state.singleWork = payload
  },
  setSingleWorkGallery(state, payload) {
    state.singleWorkGallery = payload
  },
  setOurWorksPageLoading(state, payload) {
    state.ourWorksPageLoading = payload
  }
}

const actions = {
  fetchOurWorks({ commit }) {
    commit('setOurWorksPageLoading', true)
    axiosApiInstance
      .get(`${urlBase}/our_works_list`)
      .then((res) => {
        commit('setOurWorks', res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          commit('setOurWorksPageLoading', false)
        }, 500)
      })
  },

  fetchSingleWork({ commit }, payload) {
    commit('setOurWorksPageLoading', true)
    axiosApiInstance
      .get(`${urlBase}/get_single_work`, {
        params: {
          id: payload
        }
      })
      .then((res) => {
        commit('setSingleWork', res.data.work)
        commit('setSingleWorkGallery', res.data.gallery)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('setOurWorksPageLoading', false)
        }, 500)
      })
  },

  clearSingleWork({ commit }) {
    commit('setSingleWork', {})
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
